import $ from 'jquery';

/**
 * Author Latest Posts AJAX Load More Functionality
 */
class AuthorPostsAjax {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    $(document).on('click', '#load-more-posts', this.loadMorePosts.bind(this));
  }

  loadMorePosts(e) {
    e.preventDefault();

    const $button = $(e.currentTarget);
    const $grid = $('#author-latest-grid');

    // Get data attributes
    const authorId = $button.data('author');
    const loaded = $button.data('loaded');
    const perPage = $button.data('per-page');

    // Disable button and show loading state
    $button.prop('disabled', true).addClass('loading');

    // AJAX request
    $.ajax({
      url: cloudweb_ajax.ajax_url,
      type: 'POST',
      data: {
        action: 'load_more_author_posts',
        nonce: cloudweb_ajax.nonce,
        author_id: authorId,
        offset: loaded,
        posts_per_page: perPage
      },
      success: (response) => {
        if (response.success && response.data.html) {
          // Append new posts to grid
          $grid.append(response.data.html);

          // Update loaded count
          const newLoaded = loaded + response.data.count;
          $button.data('loaded', newLoaded);

          // Hide button if no more posts
          if (!response.data.has_more) {
            $button.hide();
          } else {
            // Re-enable button
            $button.prop('disabled', false).removeClass('loading');
          }
        } else {
          // Handle error
          console.error('Error loading posts:', response.data?.message || 'Unknown error');
          $button.hide(); // Hide button on error
        }
      },
      error: (xhr, status, error) => {
        console.error('AJAX error:', error);
        $button.prop('disabled', false).removeClass('loading');

        // Optionally show user-friendly error message
        $button.text('Error loading posts');
      }
    });
  }
}

// Initialize when DOM is ready
$(document).ready(() => {
  // Only initialize on author pages
  if (document.body.classList.contains('author')) {
    new AuthorPostsAjax();
  }
});

export default AuthorPostsAjax;